import {Component, OnInit} from '@angular/core';
import {ApiConfiguration} from "./api/api-configuration";
import {TranslateService} from "@ngx-translate/core";
import {LocaleService} from "./shared/locale/locale.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(private apiConfiguration: ApiConfiguration,
              private translateService: TranslateService,
              private localeService: LocaleService) {

  }

  ngOnInit(): void {
    this.apiConfiguration.rootUrl = '/site-search';
    this.translateService.use(this.localeService.getCurrentLocale());
  }

}
